<template>
  <span>migratelocalstorage</span>
</template>

<script>
export default {
  mounted() {
    if (window.top !== window.self) {
      const data = localStorage.getItem("blockables-ark-wins");
      if (data) {
        window.parent.postMessage(
          {
            type: "LOCAL_STORAGE_MIGRATION",
            payload: data,
          },
          "*"
        );

        window.addEventListener("message", event => {
          if (event.data?.type === "LOCAL_STORAGE_MIGRATION_CONFIRMED") {
            localStorage.removeItem("blockables-ark-wins");
          }
        });
      }
    }
  },
};
</script>

<style>
</style>